// extracted by mini-css-extract-plugin
module.exports = {"icon":"Builder_icon__1_4wY"};